var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8092 7.47273C14.7638 6.49091 13.4547 5.98182 11.982 5.98182C9.38461 5.98182 7.17736 7.7328 6.38437 10.0928V10.1C6.18437 10.7 6.06619 11.3363 6.06619 12C6.06619 12.6636 6.18437 13.3 6.38437 13.9L6.37249 13.9091H6.38196C7.17287 16.2727 9.38197 18.0273 11.982 18.0273C13.3274 18.0273 14.4638 17.6636 15.3547 17.0636L15.3571 17.0655V17.0636C16.4207 16.3545 17.1298 15.3 17.3662 14.0545H11.9844V10.1818H21.4026C21.5208 10.8363 21.5844 11.5182 21.5844 12.2273C21.5844 15.2727 20.4935 17.8363 18.6026 19.5818H18.6002C16.9456 21.1091 14.682 22 11.982 22C8.07288 22 4.70013 19.7546 3.05468 16.4909V16.477C2.37435 15.1328 1.98438 13.6163 1.98438 12C1.98438 10.3823 2.37501 8.86464 3.0564 7.51952L3.05468 7.51819C4.70013 4.24546 8.07288 2 11.982 2C14.682 2 16.9365 2.99091 18.6729 4.60909L15.8092 7.47273Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.8ae2a733decb7fc02fd990f9c0521f6a.svg";
export { ForwardRef as ReactComponent };